import axios from '@/libs/axios'

export default {
  getCustomerContacts() {
    return axios.get('/user/contacts')
  },
}
